<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="filterReserves"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            :items-per-page="itemsPerPage"
            :footer-props="{
                itemsPerPageOptions: [15, 30, 100, -1],
            }"
            :height="$vuetify.breakpoint.mdAndDown ? '77vh' : '74vh'"
            fixed-header
        >
            <!-- headers -->
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 py-2"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <div class="d-flex">
                        <template>
                            <v-card
                                class="pt-2 mb-2 px-2 mx-2"
                                min-width="180px"
                                height="70px"
                            >
                                <v-card-text
                                    class="d-flex my-0 py-0 mx-0 px-0"
                                    width="100%"
                                >
                                    <v-chip
                                        class="mb-1 mt-0 ml-0 mr-1 pt-0 white--text"
                                        :color="insights[0].color"
                                        label
                                        style="height: 50px; width: 50px;"
                                    >
                                        <v-icon center>
                                            {{ insights[0].icon }}
                                        </v-icon>
                                    </v-chip>
                                    <div class="mb-1 mt-0 pt-0">
                                        <div
                                            class="d-flex mr-0 pr-0 text-capitalize"
                                        >
                                            <span
                                                style="font-size: 12px; font-weight: bold;"
                                                class="text-capitalize"
                                                >{{ insights[0].title }} ({{
                                                    status
                                                }})</span
                                            >
                                        </div>
                                        <p
                                            class="text-h6 black--text"
                                            style="font-size: 12px;"
                                        >
                                            $ {{ calculateTotal() }}
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </template>
                    </div>
                    <v-spacer />
                    <v-btn
                        rounded
                        color="primary"
                        class="mr-3 mt-3"
                        :loading="exporting"
                        :disabled="loading || !reserves.length"
                        @click="exportToExcel"
                    >
                        <v-icon class="mr-1">mdi-file-excel</v-icon>
                        EXPORT
                    </v-btn>
                </v-row>
            </template>
            <template v-slot:[`header.number`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.date`]="{ header }">
                <div class="d-flex align-center flex-nowrap">
                    <v-btn small icon v-if="activateArrow" @click="sort('asc')">
                        <v-icon size="14">mdi-arrow-up</v-icon>
                    </v-btn>
                    <v-btn small icon v-else @click="sort('desc')">
                        <v-icon size="14">mdi-arrow-down</v-icon>
                    </v-btn>
                    <v-text-field
                        :label="header.text"
                        :value="columnFilters[header.value]"
                        @input="onColumnFilterInput(header.value, $event)"
                        dense
                        class="pt-2"
                        :style="{
                            'font-size': '12px',
                            'min-width': '30px',
                        }"
                        hide-details
                    />
                </div>
            </template>
            <template v-slot:[`header.createdBy`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.item.project_name`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.projectName`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.item.storage`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.item.storeName`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.code`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.description`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.quantity`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.notes`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.total`]="{ header }">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <template v-slot:[`header.status`]="{ header }" v-if="projectId">
                <v-text-field
                    :label="header.text"
                    :value="columnFilters[header.value]"
                    @input="onColumnFilterInput(header.value, $event)"
                    dense
                    class="pt-2"
                    :style="{ 'font-size': '12px', 'min-width': '30px' }"
                    hide-details
                />
            </template>
            <!--Items--->
            <template v-slot:[`item.date`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="px-0 py-0 my-0">
                        {{
                            item.updatedOn
                                ? formatDate(item.updatedOn)
                                : formatDate(item.createdOn)
                        }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.type`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="px-0 py-0 my-0 text-capitalize">
                        {{ item.type }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.price`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="px-0 py-0 my-0">
                        {{ formatNumber(item.price) }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.total`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="px-0 py-0 my-0">
                        {{ formatNumber(item.total) }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.status`]="{ item }" v-if="projectId">
                <div class="d-flex justify-center">
                    <v-chip
                        v-if="item.status"
                        small
                        :color="colors[item.status] || 'grey'"
                        class="white--text text-capitalize"
                    >
                        {{ item.status }}
                    </v-chip>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div
                    v-if="
                        (projectId && currentUser == item.userId) ||
                            approveStock
                    "
                    class="d-flex justify-center"
                >
                    <v-btn
                        v-if="approveStock || item.status == 'onHold'"
                        small
                        icon
                        @click="openForm(item)"
                    >
                        <v-icon v-if="item.status != 'onHold'">mdi-eye</v-icon>
                        <v-icon v-else>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        small
                        icon
                        @click="openDialogReserve(item)"
                        v-if="approveStock || item.status == 'approved'"
                    >
                        <v-icon>mdi-database-arrow-left-outline</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="item.status == 'onHold'"
                        small
                        icon
                        @click="openDialogDelete(item)"
                    >
                        <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <!--Release Reserve-->
        <v-dialog
            :retain-focus="false"
            v-model="openReserve"
            persistent
            :width="$vuetify.breakpoint.mobile ? '80%' : '40%'"
        >
            <ReleaseReserve
                v-if="openReserve"
                :item="selectedItem"
                :projects="projects"
                @closeDialog="closeDialogReserve"
                @release="release"
            />
        </v-dialog>
        <!--Reserve Form-->
        <v-dialog
            :retain-focus="false"
            v-model="openReserveForm"
            persistent
            :width="$vuetify.breakpoint.mobile ? '80%' : '40%'"
        >
            <ReserveForm
                v-if="openReserveForm"
                :reserve="selectedItem"
                :originalReserve="originalItem"
                :approveStock="approveStock"
                @closeDialog="closeForm"
                @edit="replaceReserve"
            />
        </v-dialog>
        <!--Reserve Delete-->
        <v-dialog
            :retain-focus="false"
            v-model="openReserveDelete"
            persistent
            :width="$vuetify.breakpoint.mobile ? '80%' : '40%'"
        >
            <ReserveDelete
                v-if="openReserveDelete"
                :item="selectedItem"
                @closeDialog="closeDialogDelete"
                @deleteReserve="deleteReserve"
            />
        </v-dialog>

        <v-alert
            v-if="activateAlert"
            type="success"
            color="primary"
            :style="{ position: 'absolute', right: '0px', bottom: '0px' }"
        >
            <v-row no-gutters>
                <v-col cols="11">
                    <p class="my-0">{{ alertMessage }}</p>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="activateAlert = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
    </div>
</template>

<script>
import _ from 'lodash'
import ReleaseReserve from '@/components/StockRoom/ReleaseReserve.vue'
import ReserveForm from '@/components/StockRoom/ReserveForm.vue'
import ReserveDelete from '@/components/StockRoom/ReserveDelete.vue'
import API from '@/services/api'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'
import * as XLSX from 'xlsx/xlsx.mjs'

export default {
    name: 'Reserves',
    props: {
        projectId: {
            type: String,
            default: () => undefined,
        },
    },
    components: {
        ReleaseReserve,
        ReserveForm,
        ReserveDelete,
    },
    data: () => ({
        activateArrow: true,
        activateAlert: false,
        openReserveDelete: false,
        openReserveForm: false,
        loading: false,
        openReserve: false,
        selectedItem: {},
        baseHeaders: [
            {
                text: 'S/N',
                value: 'number',
                align: 'center',
                sortable: false,
                width: 45,
            },
            {
                text: 'DATE',
                value: 'date',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'CREATED BY',
                value: 'createdBy',
                align: 'center',
                sortable: false,
                width: 150,
            },
            {
                text: 'FROM',
                value: 'item.project_name',
                align: 'center',
                sortable: false,
                width: 300,
            },
            {
                text: 'TO',
                value: 'projectName',
                align: 'center',
                sortable: false,
                width: 300,
            },
            {
                text: 'STORAGE',
                value: 'item.storage',
                align: 'center',
                sortable: false,
                width: 95,
            },
            {
                text: 'STORE NAME',
                value: 'item.storeName',
                align: 'center',
                sortable: false,
                width: 115,
            },
            {
                text: 'CODE',
                value: 'code',
                align: 'center',
                sortable: false,
                width: 30,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'center',
                sortable: false,
                width: 300,
            },
            {
                text: 'QTY',
                value: 'quantity',
                align: 'center',
                sortable: false,
                width: 50,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'center',
                sortable: false,
                width: 80,
            },
            {
                text: 'TOTAL',
                value: 'total',
                align: 'center',
                sortable: false,
                width: 100,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        reserves: [],
        search: '',
        colors: {
            onHold: '#EDC43B',
            approved: '#27BC4F',
            rejected: '#FF5252',
        },
        alertMessage: '',
        originalItem: {},
        approveStock: undefined,
        users: [],
        currentUser: undefined,
        resourceId: undefined,
        insights: [
            {
                color: '#3498DB',
                icon: 'mdi-currency-usd',
                iconColor: '#1A5276',
                title: 'TOTAL RESERVES',
            },
        ],
        itemsPerPage: 15,
        columnFilters: {},
        debouncedColumnFilters: {},
        filterTimeouts: {},
        exporting: false,
        status: '',
    }),
    async mounted() {
        await this.loadReservesByStatus()
    },
    beforeDestroy() {
        Object.values(this.filterTimeouts).forEach(clearTimeout)
    },
    computed: {
        ...mapState(['notificationResource']),
        headers() {
            const statusHeader = {
                text: 'STATUS',
                value: 'status',
                align: 'center',
                sortable: false,
            }
            return this.projectId
                ? [
                      ...this.baseHeaders.slice(0, -1),
                      statusHeader,
                      this.baseHeaders[this.baseHeaders.length - 1],
                  ]
                : this.baseHeaders
        },
        columnDefs() {
            const raw = value => item => {
                const cell = _.get(item, value)
                return cell === null || cell === undefined ? '' : String(cell)
            }
            const byValue = {
                date: {
                    display: item => {
                        const date = item.updatedOn || item.createdOn
                        return date ? this.formatDate(date) : ''
                    },
                    exportValue: item => {
                        const date = item.updatedOn || item.createdOn
                        if (!date) return null
                        const seconds = date._seconds || date.seconds
                        return this.toExcelSerialDate(
                            moment.unix(seconds).toDate()
                        )
                    },
                    excelType: 'date',
                },
                total: {
                    display: item => this.formatNumber(item.total),
                    filterText: raw('total'),
                },
                quantity: { filterText: raw('quantity') },
                number: { filterText: raw('number') },
            }
            return this.headers
                .filter(header => header.value != 'actions')
                .map(header => {
                    const custom = byValue[header.value] || {}
                    const display = custom.display || raw(header.value)
                    return {
                        text: header.text,
                        value: header.value,
                        display,
                        filterText: custom.filterText || display,
                        exportValue: custom.exportValue,
                        excelType: custom.excelType,
                    }
                })
        },
        filterReserves() {
            this.openResource()
            const activeFilters = this.columnDefs
                .map(column => ({
                    column,
                    term: (this.debouncedColumnFilters[column.value] || '')
                        .toString()
                        .trim()
                        .toLowerCase(),
                }))
                .filter(filter => filter.term)

            if (!activeFilters.length) {
                return this.reserves
            }
            return this.reserves.filter(reserve =>
                activeFilters.every(({ column, term }) =>
                    column
                        .filterText(reserve)
                        .toLowerCase()
                        .includes(term)
                )
            )
        },
    },
    watch: {
        notificationResource: function(resource) {
            if (resource) {
                this.resourceId = resource
                this.openResource()
                this.setNotificationResource(undefined)
            }
        },
        '$route.name': {
            immediate: false,
            async handler() {
                await this.loadReservesByStatus()
            },
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        ...mapActions(['setNotificationResource']),
        ...mapGetters(['getNotificationResource']),
        async loadReservesByStatus() {
            try {
                this.loading = true
                // Limpiamos las reservas para que la tabla se muestre vacía mientras se recarga
                this.reserves = []
                this.resourceId = this.$route.query.resourceId
                const statusMap = {
                    // Stock Room (global) reserves
                    'reserves-approved': 'approved',
                    'reserves-on-hold': 'onHold',
                    'reserves-rejected': 'rejected',
                    // Project detail reserves
                    'project-requested-items-approved': 'approved',
                    'project-requested-items-on-hold': 'onHold',
                    'project-requested-items-rejected': 'rejected',
                    // Project generic reserves
                    'project-requested-items-approved-generic': 'approved',
                    'project-requested-items-on-hold-generic': 'onHold',
                    'project-requested-items-rejected-generic': 'rejected',
                    // Archive project reserves
                    'archive-project-requested-items-approved': 'approved',
                    'archive-project-requested-items-on-hold': 'onHold',
                    'archive-project-requested-items-rejected': 'rejected',
                }
                this.status = statusMap[this.$route.name] || ''
                if (this.projectId) {
                    this.reserves = await API.getReserves(
                        this.projectId,
                        this.status
                    )
                } else {
                    this.reserves = await API.getReserves('', this.status)
                }
                this.projects = await API.getLiteProjects({})
                const {
                    data: { users },
                } = await API.getLiteUsers()
                // format users as keys
                this.usersData = {}
                users.forEach(user => {
                    this.usersData[user.id] = user
                })
                this.reserves.forEach(reserve => {
                    const user = this.usersData[reserve.userId]
                    if (user) {
                        reserve.createdBy = user.name
                    }
                })
                const {
                    data: { user },
                } = await API.getMyInfo()
                this.approveStock = user.permissions.find(
                    p => p == 'approveStock'
                )
                this.currentUser = user.id
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        onColumnFilterInput(columnValue, term) {
            this.$set(this.columnFilters, columnValue, term)
            this.debounceColumnFilter(columnValue, term)
        },
        // Debouncing independiente por columna
        debounceColumnFilter(columnValue, term) {
            clearTimeout(this.filterTimeouts[columnValue])
            this.filterTimeouts[columnValue] = setTimeout(() => {
                this.$set(this.debouncedColumnFilters, columnValue, term)
            }, 300)
        },
        async exportToExcel() {
            try {
                this.exporting = true
                const columns = this.columnDefs
                const rows = this.reserves.map(reserve => {
                    const row = {}
                    columns.forEach(column => {
                        if (column.exportValue) {
                            row[column.text] = column.exportValue(reserve)
                        } else {
                            row[column.text] = column.display(reserve)
                        }
                    })
                    return row
                })
                const worksheet = XLSX.utils.json_to_sheet(rows, {
                    header: columns.map(column => column.text),
                })
                this.applyExcelCellFormats(worksheet, columns, rows.length)
                worksheet['!cols'] = columns.map(column => ({
                    wch: this.exportColumnWidth(column.value),
                }))
                const workbook = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Reserves')
                XLSX.writeFile(
                    workbook,
                    `reserves_${this.status || 'project'}_${moment().format(
                        'YYYY-MM-DD'
                    )}.xlsx`
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.exporting = false
            }
        },
        exportColumnWidth(columnValue) {
            const widths = {
                description: 40,
                notes: 40,
                'item.project_name': 25,
                projectName: 25,
                'item.storeName': 25,
                createdBy: 20,
                code: 18,
                'item.storage': 15,
                date: 14,
            }
            return widths[columnValue] || 12
        },
        toExcelSerialDate(date) {
            const utcDate = Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()
            )
            return (utcDate - Date.UTC(1899, 11, 30)) / 86400000
        },
        applyExcelCellFormats(worksheet, columns, rowCount) {
            columns.forEach((column, columnIndex) => {
                if (column.excelType !== 'date') return
                const columnLetter = XLSX.utils.encode_col(columnIndex)
                for (let rowIndex = 2; rowIndex <= rowCount + 1; rowIndex++) {
                    const cellAddress = `${columnLetter}${rowIndex}`
                    const cell = worksheet[cellAddress]
                    if (cell && cell.v != null && cell.v !== '') {
                        cell.t = 'n'
                        cell.z = 'yyyy-mm-dd'
                    }
                }
            })
        },
        formatNumber(value) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0,
            }).format(Math.ceil(value))
        },
        sort(direction) {
            if (direction == 'asc') {
                this.activateArrow = false
                this.reserves.sort(
                    (a, b) =>
                        (a.updatedOn
                            ? a.updatedOn._seconds || a.updatedOn.seconds
                            : a.createdOn._seconds || a.createdOn.seconds) -
                        (b.updatedOn
                            ? b.updatedOn._seconds || b.updatedOn.seconds
                            : b.createdOn._seconds || b.createdOn.seconds)
                )
                return null
            } else if (direction == 'desc') {
                this.activateArrow = true
                this.reserves.sort(
                    (a, b) =>
                        (b.updatedOn
                            ? b.updatedOn._seconds || b.updatedOn.seconds
                            : b.createdOn._seconds || b.createdOn.seconds) -
                        (a.updatedOn
                            ? a.updatedOn._seconds || a.updatedOn.seconds
                            : a.createdOn._seconds || a.createdOn.seconds)
                )
                return null
            }
        },
        formatDate(date) {
            return moment
                .unix(date._seconds || date.seconds)
                .format('YYYY-MM-DD')
        },
        addReserve(reserve) {
            this.reserves.splice(0, 0, reserve)
        },
        replaceReserve(reserve) {
            const index = this.reserves.findIndex(r => r.id == reserve.id)
            if (index > -1) {
                this.reserves.splice(index, 1, {
                    ...this.reserves[index],
                    ...reserve,
                })
            }
            this.closeForm()
            this.alertMessage = 'The reserve was successfully changed'
            this.activateAlert = true
        },
        deleteReserve(id) {
            const index = this.reserves.findIndex(r => r.id == id)
            if (index > -1) {
                this.reserves.splice(index, 1)
            }
            this.closeDialogDelete()
            this.alertMessage = 'Reserve was successfully trashed'
            this.activateAlert = true
        },
        async release(release) {
            try {
                this.loading = true
                const newRelease = await API.releaseReserve({
                    reserveId: this.selectedItem.id,
                    projectId: this.selectedItem.projectId,
                    targetProjectId: release.projectId,
                    quantity: release.quantity,
                    notes: release.notes,
                })
                this.addReserve(newRelease)
                this.closeDialogReserve()
                this.alertMessage =
                    'The creation of the release has been successful'
                this.activateAlert = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openDialogDelete(item) {
            this.openReserveDelete = true
            this.selectedItem = _.cloneDeep(item)
        },
        closeDialogDelete() {
            this.openReserveDelete = false
            this.selectedItem = {}
        },
        openForm(item) {
            this.openReserveForm = true
            this.selectedItem = _.cloneDeep(item)
            this.originalItem = _.cloneDeep(item)
        },
        closeForm() {
            this.openReserveForm = false
            this.selectedItem = {}
            this.originalItem = {}
        },
        openDialogReserve(item) {
            this.openReserve = true
            this.selectedItem = _.cloneDeep(item)
        },
        closeDialogReserve() {
            this.openReserve = false
            this.selectedItem = {}
        },
        calculateTotal() {
            let total = 0
            total = this.reserves.reduce(
                (accumulator, item) => accumulator + Number(item.total),
                0
            )
            return this.numberFormat(total)
        },
        numberFormat(amount) {
            return new Intl.NumberFormat('de-DE').format(Math.ceil(amount))
        },
        openResource() {
            if (this.resourceId) {
                const resource = this.reserves.find(
                    r => r.id == this.resourceId
                )
                if (resource) {
                    this.resourceId = undefined
                    this.openForm(resource)
                }
            }
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
    position: sticky;
    z-index: 1;
}
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
</style>
